export interface ContactGroupBindContactsRequestModel {
  emails: string[];
}
